// File: client_serena/src/hooks/useAuth.js

import { createContext, useContext, useEffect, useState } from "react";
import { getAuth, onIdTokenChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase"; // ✅ Your Firestore instance

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [role, setRole] = useState(null);
  const [userToken, setUserToken] = useState(() => {
    return localStorage.getItem("serena_token") || "";
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onIdTokenChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        setUser(firebaseUser);
        try {
          const token = await firebaseUser.getIdToken();
          setUserToken(token);
          localStorage.setItem("serena_token", token);

          const docRef = doc(db, "users", firebaseUser.uid);
          const docSnap = await getDoc(docRef);
          setRole(docSnap.exists() ? docSnap.data().role || "user" : "user");
        } catch (err) {
          console.error("Error fetching user token or role:", err);
          setRole("user");
        }
      } else {
        setUser(null);
        setRole(null);
        setUserToken("");
        localStorage.removeItem("serena_token");
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  return (
    <AuthContext.Provider value={{ user, role, userToken, loading }}>
      {!loading && children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}

